import { defineMessage } from 'services/localization';

export const messages = {
    sectionHeaderText: defineMessage('bill_to_po_matching_1'),
    noMatchedBills: defineMessage('this_purchase_order_is__y_matched_with_any_bill'),
    markAsBilledButtonTitle: defineMessage('mark_this_purchase_order_as_billed'),
    unmarkAsBilledMenuItemTitle: defineMessage('unmark_this_purchase_order_as_billed'),
    allocationsToApprovedBills: defineMessage('allocations_to_approved_bills'),
    allocatedAmount: defineMessage('allocations_to_bills_on_approval'),
    remaining: defineMessage('remaining'),
    extraAmount: defineMessage('remaining_extra_extraamount_are_allowed'),
    showTable: defineMessage('matched_bills'),
};
